export default __webpack_public_path__ + "static/media/Kandji.3325f893.svg";